import {
  createReceiver,
  createSender,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL = 'chat/'

const ADD_CHAT_QUESTION = prefixAPI('buyer/create', MODEL)
const ADD_CHAT = prefixAPI('create/', MODEL)
const CHECK_CHAT = prefixAPI('check/{?shop}', MODEL)

export const AddChatQuestion = createSender(ADD_CHAT_QUESTION)
export const AddChat = createSender(ADD_CHAT)
export const CheckAvailableChats = createReceiver(CHECK_CHAT)
